import { buildColumnMaps } from "./buildColumnsMapHelper";

export function buildDebtors(
    columns = [],
    rows = []
) {
    const { detailMap, taxMap } = buildColumnMaps(columns);

    const debtors = rows.map(row => {
        // 1) Detalles: recorrer detailMap y extraer totales > 0
        const details = [];
        for (const [dataIndex, chargeItemId] of detailMap.entries()) {
            const raw = row[dataIndex];
            const total = parseFloat(raw);
            if (!isNaN(total) && total !== 0) {
                details.push({ charge_item_id: chargeItemId, total });
            }
        }

        // 2) Impuestos: recorrer taxMap y extraer totales > 0
        const taxes = [];
        for (const [dataIndex, chargeTaxId] of taxMap.entries()) {
            const raw = row[dataIndex];
            const total = parseFloat(raw);
            if (!isNaN(total) && total !== 0) {
                taxes.push({ charge_tax_id: chargeTaxId, total });
            }
        }

        // 3) Totales globales
        const totals = {
            taxable_total: Number(row.taxable_total),
            tax_total: Number(row.tax_total),
            total: Number(row.total),
        };

        return {
            place_id: row.place_id,
            details,
            taxes,
            totals
        };
    });

    return { debtors };
}